var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 47,
    viewBox: "0 0 34 47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 36.44c0 5.213 4.226 9.437 9.44 9.437a9.438 9.438 0 0 0 9.437-9.437c0-5.214-4.226-9.44-9.437-9.44A9.44 9.44 0 0 0 14 36.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.917 39.693a4.402 4.402 0 1 1-2.965-7.656 4.39 4.39 0 0 1 2.965 1.146m-8.852 1.92h5.717m-5.717 2.671h5.717"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.706 22.516h12.647v.013H4.706zm0-4.708h14.647v.016H4.706zm0-4.696h16.647v.006H4.706zm0-4.727h10.588v.027H4.706z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.614 33H1V1h23.946L25 22.666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.87a36d717d9e26304048412d4d4c5eb7.svg";
export { ForwardRef as ReactComponent };